import React from 'react';
import "react-router-dom";
import { SelectFinance } from './interactive/selectFinance';
import { InlineSvg } from "./inlineSvg.js";

import '../functions/player';
import { Dashboard } from './dashboard';
import {finances} from '../actions/financesArray.js';


export class Government extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      activeFinances: [],
      parentCallback: 'default',
    };

    this.checkAvailable = this.checkAvailable.bind(this);

  }
  createAlert = (msg) => {
    this.props.handleAlert(msg);
  }

  changeDashboard = (pass) => {
    if(pass.type === "upgrade"){
      if (!this.getUpgradeActive(pass.id)) {
        this.refs.dashboard.setState({
          parentCallback: pass,
        });
      }
    } else {
      this.refs.dashboard.setState({
        parentCallback: pass,
      });
    }
  }

  updateVariables = () => {
    this.setState({
      subsidyAvailable: this.props.object.subsidyAvailable,
      taxAvailable: this.props.object.taxAvailable,
      activeFinances: finances.filter((current) => {return current.active === true})
    });
  }

  enableFinance = (data) => {
    const res = this.props.object.selectNewFinance(data);
    if(res instanceof Error){
      this.createAlert("Kon de nieuwe belasting/subsidie niet activeren. " + res.message);
    }
    this.updateVariables();
  }

  getActive(){
    let active = [];
    for (var i = 0; i < this.state.activeFinances.length; i++) {
      active.push(
        <tr key={"f_"+ i}>
          <td>{this.state.activeFinances[i].type}<br/>
          {this.state.activeFinances[i].name}</td>
          <td>{this.state.activeFinances[i].amount}</td>
        </tr>
      );
    }
    return active;
  }

  getActivePreview = () => {
    let active = finances.filter((current) => { return current.active === true });
    const showMore = (active.length > 2 ? true : false)
    
    if(active.length > 2){
      active = active.splice(0 , 2);
    }

    let display = [];
    for (var i = 0; i < active.length; i++) {
      display.push(<li key={"ico"+ i} className={"icon " + active[i].icon}>&euro; {active[i].amount}</li>);
    }

    if(showMore){
      display.push(<li key={"icoMore"} className="icon">Meer...</li>);
    }

    return display;
  }

  checkAvailable(){
    this.setState({
      subsidyAvailable: this.props.object.subsidyAvailable,
      taxAvailable: this.props.object.taxAvailable,
    })
  }

  toggleModal = () => {
    this.checkAvailable();
    this.refs.dashboard.handleModaltoggle();
  }

  render() {
    return(
      <div className="entityWrap">
        <div className="hud" style={this.props.object.imageStyle} onClick={this.toggleModal}>
          <div className="inner" style={this.props.object.hudStyle}>
            <div className="hudContent" style={{paddingBottom: "60%"}}>
              <div className="name" style={{backgroundColor: this.props.object.color}}>
                {this.props.object.name}
              </div>
              <ul className="data">
                {this.getActivePreview()}
              </ul>
            </div>
          </div>
        </div>
        <img className="boardElement boardElement--main" src={this.props.object.image} alt='Board Element' style={this.props.object.imageStyle}/>
        <Dashboard createAlert={this.createAlert} callbackPurchase={this.enableFinance} parentCallback={this.state.parentCallback} ref="dashboard" headerText={this.props.object.name} self={this.props.object}>
          <div className="row">
            <div className="col col--data col--data-small">
              <table className="purchaseComparison">
                <thead>
                  <tr><td colSpan="3">Subsidies</td></tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Slimme technieken</td>
                    <td className="value">{this.props.object.getFinances("smartAppliances")}</td>
                    <td>(&euro;)</td>
                  </tr>
                  <tr>
                    <td>Kleine centrales</td>
                    <td className="value">{this.props.object.getFinances("decentrals")}</td>
                    <td>(&euro;)</td>
                  </tr>
                  <tr>
                    <td>Windparken op zee</td>
                    <td className="value">{this.props.object.getFinances("windfarms")}</td>
                    <td>(&euro;)</td>
                  </tr>
                  <tr>
                    <td>Zonne-energiecentrales</td>
                    <td className="value">{this.props.object.getFinances("solarfarms")}</td>
                    <td>(&euro;)</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="col col--data col--data-small">
              <table className="purchaseComparison">
                <thead>
                  <tr><td colSpan="3">Belastingen</td></tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Elektriciteit uit kolen</td>
                    <td className="value">{this.props.object.getFinances("coalPower")}</td>
                    <td>(&euro;)/MWU</td>
                  </tr>
                  <tr>
                    <td>Elektriciteit uit kolen en gas</td>
                    <td className="value">{this.props.object.getFinances("gasCoalPower")}</td>
                    <td>(&euro;)/MWU</td>
                  </tr>
                  <tr>
                    <td>Vergunning voor gas- en kolencentrales</td>
                    <td className="value">{this.props.object.getFinances("blackPermit")}</td>
                    <td>(&euro;)/Centrale</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="row">
            <SelectFinance createAlert={this.createAlert} typeText={"subsidie"} finances={[0,1,2,3]} self={this.props.object} callbackPurchase={this.enableFinance}/>
          </div>
          <div className="row">
            <SelectFinance createAlert={this.createAlert} typeText={"belasting"} finances={[4,5,6,7,8]} self={this.props.object} callbackPurchase={this.enableFinance}/>
          </div>
          <div className="row field-hidden">
            <div className="col col--upgrade" onClick={() => {this.changeDashboard({type: "finance", id: [0]})}}>
              <div className="upgrade">
                <div className="upgrade--image clickAble">
                  <InlineSvg className="svg" src={require("../assets/elements/Icon - Smart network.svg")}/>
                </div>
                <div className="upgrade--name">Slimme technieken</div>
              </div>
            </div>
            <div className="col col--upgrade" onClick={() => {this.changeDashboard({type: "finance", id: [1, 2, 3]})}}>
              <div className="upgrade">
                <div className="upgrade--image clickAble">
                  <InlineSvg className="svg" src={require("../assets/elements/Icon - windfarm.svg")}/>
                </div>
                <div className="upgrade--name">Groene centrales</div>
              </div>
            </div>
            <div className="col col--upgrade" onClick={() => {this.changeDashboard({type: "finance", id: [4, 5, 6, 7]})}}>
              <div className="upgrade">
                <div className="upgrade--image clickAble">
                  <InlineSvg className="svg" src={require("../assets/elements/Icon - gasplant   .svg")}/>
                </div>
                <div className="upgrade--name">Belasting stroom</div>
              </div>
            </div>
            <div className="col col--upgrade" onClick={() => {this.changeDashboard({type: "finance", id: [8]})}}>
              <div className="upgrade">
                <div className="upgrade--image clickAble">
                  <InlineSvg className="svg" src={require("../assets/elements/Icon - powerplant.svg")}/>
                </div>
                <div className="upgrade--name">Vergunning zwarte centrale</div>
              </div>
            </div>
          </div>
        </Dashboard>
      </div>
    )
  }

}

//NOTE: OLDMODALCONTENT
//
// <Modal show={this.state.isOpen} onClose={this.toggleModal}>
//   {this.props.object.name}
//   <table>
//     <tbody style={{backgroundColor: this.props.object.color}}>
//       <tr>
//         <td colSpan="2"><em>Functions:</em></td>
//       </tr>
//       <tr>
//         <td>
//           <strong>Selecteer een nieuwe subsidie</strong>
//           <SelectFinance callbackEnable={this.enableFinance} available={this.state.subsidyAvailable} finances={this.props.object.getAvailableFinance("subsidy")} type="subsidy"/>
//         </td>
//       </tr>
//
//       <tr>
//         <td>
//           <strong>Selecteer een nieuwe belasting</strong>
//           <SelectFinance callbackEnable={this.enableFinance} available={this.state.taxAvailable} finances={this.props.object.getAvailableFinance("tax")} type="tax"/>
//         </td>
//       </tr>
//     </tbody>
//   </table>
// </Modal>



// WEBPACK FOOTER //
// ./src/components/government.js